<template>
  <div>
    <headNav :routeAddress="address">
      <div slot="headNavText">{{$t('message.rz_succ')}}</div>
    </headNav>
    <div class="container">
      <img src="../../../assets/images/3x/tjcg.png" alt="">
      <p>{{$t('message.gxntjcg')}}！</p>
<!--      <p>{{$t('message.fksjts')}}</p>-->
      <van-button type="primary" round size="normal" @click="goIndex" class="btns" block>
        {{$t('message.reback')}}{{$t('message.home')}}
      </van-button>
    </div>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  export default {
    name: "auth_succ",
    data(){
      return{
        address:'/home'
      }
    },
    components: {
      headNav
    },
    methods:{
      goIndex(){
          this.$router.push('/home')
      }
    }
  }
</script>

<style scoped lang="scss">
  .btns{
    @include defaultBtn;
    margin-top: 3rem;
    color: #fff!important;
  }
  #headNav {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 1.3rem;
    line-height: 1.3rem;
    background-color: #fff;
    border-bottom: 1px solid rgba(122, 122, 122, 0.1);

    .title {
      font-size: 18px;
      color: #262626;
      font-weight: 500;
    }

    .leftArrow {
      font-size: 18px;
      display: flex;
      align-items: center;
      width: 40px;
    }
  }

  .container {
    width: 90%;
    margin: 0 auto;
    padding: 4.3rem 15px 0;
    text-align: center;

    :nth-child(2) {
      font-size: 0.46rem;
      font-weight: 600;
      color: #1B1B1B;
    }

    :nth-child(3) {
      font-size: 0.41rem;
      font-weight: 400;
      color: #B1B0B0;
      text-align: center;
    }

    img {
      width: 2.6rem;
      height: 2.6rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/auth_succ.vue